// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","logo":"footer_logo__IRoNB","linkContainer":"footer_linkContainer__lfK2w","link":"footer_link__ylPIY","signOut":"footer_signOut__ZiRcf"};